<script setup lang="ts">
useSeoMeta({
  title: 'Vergelijk Makelaars in Jouw Regio | Vind de Beste Makelaar',
  description:
    'Vind en vergelijk de beste makelaars in jouw regio. Gebaseerd op echte verkoopcijfers en prestaties. Gratis en onafhankelijk advies.',
  ogTitle: 'Vergelijk Makelaars in Jouw Regio | Vind de Beste Makelaar',
  ogDescription:
    'Vind en vergelijk de beste makelaars in jouw regio. Gebaseerd op echte verkoopcijfers en prestaties. Gratis en onafhankelijk advies.',
  ogImage: '/images/social-share.jpg',
  twitterCard: 'summary_large_image',
})
</script>

<template>
  <div class="homepage">
    <HomeHero />
    <HomeUSP />
    <HomeStats />
    <HomeHowItWorks />
    <HomeCities />
    <HomeTestimonials />
    <HomeFaq />
  </div>
</template>
